// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PatientTCEntLib2SecuritySecureModelsSecureInt64Response {
    static getAttributeTypeMap() {
        return PatientTCEntLib2SecuritySecureModelsSecureInt64Response.attributeTypeMap;
    }
}
PatientTCEntLib2SecuritySecureModelsSecureInt64Response.discriminator = undefined;
PatientTCEntLib2SecuritySecureModelsSecureInt64Response.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "string"
    }
];
//# sourceMappingURL=patientTCEntLib2SecuritySecureModelsSecureInt64Response.js.map